import { getThemeColors, getUSANumberFormat } from "app/utils/utils";
import IPPageNumber from "../IPPageNuber";
import { ProposalTypes } from "app/utils/types";
import HexagonImg from "../../images/hexagonImg.png";
import { getColorVariations } from "app/utils/colorUtils";
import { getSessionStore } from "app/utils/sessionStore";

const IPappendix = ({
  appendix,
  proposalType,
  pageNumber,
  newPage,
}: {
  appendix: any;
  proposalType: string;
  pageNumber: string | number;
  newPage?: boolean;
}) => {
  const { branding } = getSessionStore("lookUpResponse");
  const { secondaryColor } = getThemeColors(branding);
  const { lifePolicies, disabilityPolicies } = appendix;

  const isKeyPerson = proposalType === ProposalTypes.KeyPersonInsurance;

  const disabilityPolicyLedger = [
    { header: isKeyPerson ? "Employee" : "Shareholder" },
    { header: "Premium Expiration" },
    { header: "Benefit Expiration" },
    { header: "Insurance Company" },
    { header: "Insurance Type" },
    { header: "Policy Type" },
    { header: "Lump Sum Benefit" },
    { header: "Monthly Benefit " },
    { header: "Duration (Months)" },
    { header: "Total DI Benefit" },
    { header: "Annual Premium" },
  ];

  const defaultLedger = [
    { header: isKeyPerson ? "Employee" : "Shareholder" },
    { header: "Premium Expiration" },
    { header: "Benefit Expiration" },
    { header: "Insurance Company" },
    { header: "Insurance Type" },
    { header: "Policy Type" },
    { header: "Death Benefit" },
    { header: "Annual Premium" },
  ];

  const additionalFields = [{ header: "Living Benefit Coverage" }, { header: "Living Benefit" }];

  const lifePolicyLedger = isKeyPerson ? [...defaultLedger, ...additionalFields] : defaultLedger;

  const renderContent = () => {
    const getVariationColorDisabilityPolicy = getColorVariations(
      secondaryColor,
      disabilityPolicyLedger.length,
    );
    const variationColorDisabilityPolicy = getVariationColorDisabilityPolicy.reverse();
    if (newPage) {
      return (
        <div className="px-[2em] w-full max-w-[56em] mx-auto p-[1.75em]">
          <div
            className="text-xl font-bold mb-2 text-center conthrax-font"
            style={{ color: "#495057" }}
          >
            Proposed Disability Policy Ledger
          </div>
          <table className="w-full border-collapse">
            <thead>
              <tr>
                {disabilityPolicyLedger?.map(({ header }, index) => (
                  <th
                    key={header}
                    className="p-1 text-center font-semibold text-white border-2 border-white"
                    style={{
                      backgroundColor: variationColorDisabilityPolicy[index],
                      fontSize: "8.53px",
                    }}
                  >
                    {header}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {disabilityPolicies?.map((policy: any, index: any) => (
                <tr
                  key={index}
                  style={{ backgroundColor: "#EEEEEE", color: "#000000", fontSize: "7.07px" }}
                >
                  <td className="p-1 text-center border-2 border-white">
                    {proposalType === ProposalTypes.KeyPersonInsurance
                      ? policy?.kpEmployees?.name
                      : policy?.shareholder?.name || "-"}
                  </td>
                  <td className="p-1 text-center border-2 border-white" style={{}}>
                    {policy?.expirationYears || "-"}
                  </td>
                  <td className="p-1 text-center border-2 border-white">
                    {policy?.benefitExpiration || "-"}
                  </td>
                  <td className="p-1 text-center border-2 border-white">
                    {policy?.insuranceCompany?.name || "-"}
                  </td>
                  <td className="p-1 text-center border-2 border-white">
                    {policy?.insuranceType || "-"}
                  </td>
                  <td className="p-1 text-center border-2 border-white">
                    {policy?.insuranceCompany?.productType} - {policy?.insuranceProduct?.name}
                  </td>
                  <td className="p-1 text-center border-2 border-white">
                    ${getUSANumberFormat(policy?.lumpSumBenefit, false)}
                  </td>
                  <td className="p-1 text-center border-2 border-white">
                    ${getUSANumberFormat(policy?.monthlyBenefit, false)}
                  </td>
                  <td className="p-1 text-center border-2 border-white">
                    {policy?.duration || "-"}
                  </td>
                  <td className="p-1 text-center border-2 border-white">
                    ${getUSANumberFormat(policy?.totalDIBenefit, false)}
                  </td>
                  <td className="p-1 text-center border-2 border-white">
                    ${getUSANumberFormat(policy?.annualPremium, false)}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      );
    }

    const getVariationColor = getColorVariations(secondaryColor, lifePolicyLedger.length);
    const variationColorLifePolicy = getVariationColor.reverse();
    return (
      <div className="px-[2em] w-full max-w-[56em] mx-auto p-[1.75em]">
        <div className="text-xl font-bold mb-3 text-center interactive-proposal-text conthrax-font">
          Appendix
        </div>
        <div>
          <div
            className="text-xl font-bold mb-2 text-center conthrax-font"
            style={{ color: "#495057" }}
          >
            Proposed Life Policy Ledger
          </div>
          <table className="w-full border-collapse">
            <thead>
              <tr>
                {lifePolicyLedger?.map(({ header }, index) => (
                  <th
                    key={header}
                    className="p-1 text-center font-semibold text-white border-2 border-white"
                    style={{ backgroundColor: variationColorLifePolicy[index], fontSize: "8.53px" }}
                  >
                    {header}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {lifePolicies?.map((policy: any, index: any) => (
                <tr
                  key={index}
                  style={{ backgroundColor: "#EEEEEE", color: "#000000", fontSize: "7.07px" }}
                >
                  <td className="p-1 text-center border-2 border-white">
                    {proposalType === ProposalTypes.KeyPersonInsurance
                      ? policy?.kpEmployees?.name
                      : policy?.shareholder?.name || "-"}
                  </td>
                  <td className="p-1 text-center border-2 border-white">
                    {policy?.expirationYears || "-"}
                  </td>
                  <td className="p-1 text-center border-2 border-white">
                    {policy?.benefitExpiration || "-"}
                  </td>
                  <td className="p-1 text-center border-2 border-white">
                    {policy?.insuranceCompany?.name || "-"}
                  </td>
                  <td className="p-1 text-center border-2 border-white">
                    {policy?.insuranceType || "-"}
                  </td>
                  <td className="p-1 text-center border-2 border-white">
                    {policy?.insuranceCompany?.productType} - {policy?.insuranceProduct?.name}
                  </td>
                  <td className="p-1 text-center border-2 border-white">
                    ${getUSANumberFormat(policy?.deathBenefit, false)}
                  </td>
                  <td className="p-1 text-center border-2 border-white">
                    ${getUSANumberFormat(policy?.annualPremium, false)}
                  </td>
                  {proposalType === ProposalTypes.KeyPersonInsurance && (
                    <>
                      <td className="p-1 text-center border-2 border-white">
                        {policy?.criticalIllness ? "Yes" : "No"}
                      </td>
                      <td className="p-1 text-center border-2 border-white">
                        ${getUSANumberFormat(policy?.ciBenefitAmount, false)}
                      </td>
                    </>
                  )}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    );
  };

  return (
    <div className="flex flex-col h-full relative min-h-screen">
      <div className="relative z-20">{renderContent()}</div>

      <div className="absolute bottom-0 left-0 w-full">
        <div
          className="h-[350px] bg-cover bg-center"
          style={{
            backgroundImage: `url(${HexagonImg})`,
            backgroundSize: "cover",
          }}
        />
        <div className="px-[3em] w-full max-w-[56em] mx-auto p-[1.75em] pt-1">
          <IPPageNumber number={pageNumber} />
        </div>
      </div>
    </div>
  );
};

export default IPappendix;
